<div class="container">
  <div class="card m-3">
    <div class="card title text-center m-2">
      <h3>The Novel CoronaVirus, Covid19</h3>
    </div>
    <div class="card-text">
      <div class="row">
        <div class="col m-5">
          <p>Coronaviruses are a family of viruses that can cause illnesses such as the common cold, severe acute respiratory syndrome (SARS) and Middle East respiratory syndrome (MERS).</p> <hr> <p>In 2019, a new coronavirus was identified as the cause of a disease outbreak that originated in China.
            The virus is now known as the severe acute respiratory syndrome coronavirus 2 (SARS-CoV-2). The disease it causes is called coronavirus disease 2019 (COVID-19). In March 2020, the World Health Organization (WHO) declared the COVID-19 outbreak a pandemic.</p>
        </div>
        <div class="col m-5">
          <h4>Do's</h4>
          <ul>
            <li>Wash your hands.</li>
            <li>Wear a Mask.</li>
            <li>Avoid Contact with sick people.</li>
            <li>Always cover your cough or sneeze.</li>
          </ul>
          <h4>Symptoms</h4>
          <ul>
            <li>Dry Cough.</li>
            <li>High Fever.</li>
            <li>Sore Throat.</li>
            <li>Difficulty in Breathing.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<app-img></app-img>
